import { render } from "./StopIcon.vue?vue&type=template&id=ecbf19ae"
const script = {}

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/StopIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ecbf19ae"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ecbf19ae', __exports__)) {
    api.reload('ecbf19ae', __exports__)
  }
  
  module.hot.accept("./StopIcon.vue?vue&type=template&id=ecbf19ae", () => {
    api.rerender('ecbf19ae', render)
  })

}


export default __exports__